export enum WhoWinsGame {
  JinroTeam = "jinroteam",
  MurabitoTeam = "murabitoteam",
}
